<template>
  <div>
    <b-card-text>
      対象のHPを回復します。
    </b-card-text>
    <b-card title="対象">
      <b-form-group id="target" label="対象"
        label-cols="3">
        <b-form-select v-model="innerValue.arguments.target" 
          :options="[
            { value:{ '@arg':'target' }, text:'選択対象' },
            { value:{ '@arg':'player' }, text:'自己' },
          ]" />
      </b-form-group>
    </b-card>
    <b-card title="効果">
      <b-alert show variant="secondary">
        効果量=自己MND×MND係数+効果固定値 + 対象VIT×VIT係数
      </b-alert>
      <b-form-group id="MNDRatio" label="MND係数"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.MNDRatio" 
          type="number" :min="0" :max="99" :step="0.1" number />
      </b-form-group>
      <b-form-group id="AHeal" label="効果固定値"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.AHeal" 
          type="number" :min="0" :max="99" :step="1" number />
      </b-form-group>
      <b-form-group id="accurate" label="減衰乱数"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.accurate" 
          type="number" :min="0" :max="1" :step="0.01" number />
      </b-form-group>
      <b-form-group id="MNDRatio" label="VIT係数"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.VITRatio" 
          type="number" :min="0" :max="99" :step="0.1" number />
      </b-form-group>
    </b-card>
    <b-card title="その他">
      <b-form-group id="Delay" label="遅延"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.Delay" 
          type="number" :min="0" :max="5000" :step="1" number />
      </b-form-group>
    </b-card>
    <b-card title="異常状態">
      <b-form-group id="PowerRatio" label="Lv係数"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.PowerRatio" 
          type="number" :min="0" :max="99" :step="0.1" number />
      </b-form-group>
    </b-card>
    <b-button variant="danger" size="sm"
      @click="$emit('removeCode')">
      <b-icon icon="x" />削除
    </b-button>
  </div>
</template>

<script>
const newCode = ()=>{
  return {
    player: { '@arg':'player' },
    target: { '@arg':'target' },
    dice: { '@arg':'dice' },

    hit:1000, dodge:1000,

    AHeal: 1,
    accurate: 1.0,
    MNDRatio: 1.0, VITRatio: 1.0,

    Delay: 1000,

    PowerRatio: 0.0,
  }
}
export default {
  props: {
    value: Object
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  watch: {
    'innerValue.arguments' () {
      this.$emit('input', this.innerValue)
    },
    value (v) {
      this.innerValue = v
    }
  },
  newCode
}
</script>

<style lang="scss" scoped>

</style>
